import { create } from "zustand";
import type { GameDefinition } from "@spieleparadies/shared";

interface GameCatalogState {
  games: GameDefinition[];
  setGames: (games: GameDefinition[]) => void;
  getTitle: (gameId: string) => string;
}

/**
 * Cache des Spiele-Katalogs vom Server, damit Lobby, Spiel-Header und
 * andere Stellen den Titel eines Spiels zeigen können, ohne den Server
 * erneut zu fragen.
 */
export const useGameCatalogStore = create<GameCatalogState>((set, get) => ({
  games: [],
  setGames: (games) => set({ games }),
  getTitle: (gameId) =>
    get().games.find((g) => g.id === gameId)?.title ?? gameId,
}));
